export default __webpack_public_path__ + "static/media/financiamento-imobiliario.98c9561e.svg";